import { Logout, UnauthenticatedPage } from '@hcs/authn';
import { LayoutGlobalHeaderOutlet } from '@hcs/design-system';

import { OmDemoGlobalHeader } from '../../../navigation/OmDemoGlobalHeader';
import { LoginPage } from '../pages';
import { VIEW_PATHS_ACCESS_OM_DEMO } from '..';

export const routes = () => [
  {
    element: <LayoutGlobalHeaderOutlet header={<OmDemoGlobalHeader />} />,
    children: [
      {
        path: VIEW_PATHS_ACCESS_OM_DEMO.LOGIN,
        element: (
          <UnauthenticatedPage>
            <LoginPage />
          </UnauthenticatedPage>
        ),
      },
      {
        path: VIEW_PATHS_ACCESS_OM_DEMO.LOGOUT,
        element: <Logout />,
      },
    ],
  },
];
